import { ThemeProvider } from '@mui/material/styles';
import AppBar from '@mui/material/AppBar';
import Hidden from '@mui/material/Hidden';
import Toolbar from '@mui/material/Toolbar';
import clsx from 'clsx';
import { forwardRef, memo, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { changeFuseTheme, selectFuseCurrentLayoutConfig, selectToolbarTheme } from 'app/store/fuse/settingsSlice';
import { selectFuseNavbar } from 'app/store/fuse/navbarSlice';
import AdjustFontSize from '../../shared-components/AdjustFontSize';
import FullScreenToggle from '../../shared-components/FullScreenToggle';
import LanguageSwitcher from '../../shared-components/LanguageSwitcher';
import NotificationPanelToggleButton from '../../shared-components/notificationPanel/NotificationPanelToggleButton';
import NavigationShortcuts from '../../shared-components/NavigationShortcuts';
import NavigationSearch from '../../shared-components/NavigationSearch';
import NavbarToggleButton from '../../shared-components/NavbarToggleButton';
import UserMenu from '../../shared-components/UserMenu';
import QuickPanelToggleButton from '../../shared-components/quickPanel/QuickPanelToggleButton';
import ChatPanelToggleButton from '../../shared-components/chatPanel/ChatPanelToggleButton';
import { Autocomplete, Box, Button, Dialog, IconButton, Menu, MenuItem, Slide, TextField, Typography } from '@mui/material';
import FuseSvgIcon from '@fuse/core/FuseSvgIcon/FuseSvgIcon';
import { useState } from 'react';
import { styled, useTheme } from '@mui/styles';
import FuseScrollbars from '@fuse/core/FuseScrollbars/FuseScrollbars';
import FuseSettingsViewerDialog from 'app/theme-layouts/shared-components/FuseSettingsViewerDialog';
import { useSwipeable } from 'react-swipeable';
import FuseSettings from '@fuse/core/FuseSettings/FuseSettings';
import FuseThemeSchemes from '@fuse/core/FuseThemeSchemes/FuseThemeSchemes';
import themesConfig from 'app/configs/themesConfig';
import { motion } from 'framer-motion';
import HeaderFullScreenToggle from '../../shared-components/FullScreenToggle';
import { useTranslation } from 'react-i18next';
import { useThemeMediaQuery } from '@fuse/hooks';
import axios from 'axios';
import { selectUser } from 'app/store/userSlice';
import { Link, useNavigate } from 'react-router-dom';
import { showMessage } from 'app/store/fuse/messageSlice';






const StyledDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialog-paper': {
    position: 'fixed',
    width: 380,
    maxWidth: '90vw',
    backgroundColor: theme.palette.background.paper,
    top: 0,
    height: '100%',
    minHeight: '100%',
    bottom: 0,
    right: 0,
    margin: 0,
    zIndex: 1000,
    borderRadius: 0,
  },
}));

const Transition = forwardRef(function Transition(props, ref) {
  const theme = useTheme();
  return <Slide direction={theme.direction === 'ltr' ? 'left' : 'right'} ref={ref} {...props} />;
});

function ToolbarLayout1(props) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const user = useSelector(selectUser);
  const { t } = useTranslation('translate-language');
  const config = useSelector(selectFuseCurrentLayoutConfig);
  const [comp, setComp] = useState([]);
  const [currency, setCurrency] = useState('');
  const [currencyData, setCurrencyData] = useState([]);
  const [historyCurrency, setHistoryCurrency] = useState(false);
  const [is_save, setIsSave] = useState(false);
  const [open, setOpen] = useState(false);
  const [continentData, setContinentData] = useState([]);
  const [inputValue, setInputValue] = useState('');
  const [productData, setProductData] = useState([]);
  const [branch, setBranch] = useState([]);
  const [continent, setContinent] = useState('');
  const handlerOptions = {
    onSwipedLeft: () => {
      return open && theme.direction === 'rtl' && handleClose();
    },
    onSwipedRight: () => {
      return open && theme.direction === 'ltr' && handleClose();
    },
  };
  const [anchorEl, setAnchorEl] = useState(null);
  const settingsHandlers = useSwipeable(handlerOptions);
  const shemesHandlers = useSwipeable(handlerOptions);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  }
  const handleClose = () => {
    setOpen(false);
    setAnchorEl(null);
  };
  const isMobile = useThemeMediaQuery((theme) => theme.breakpoints.down('sm'));

  const navbar = useSelector(selectFuseNavbar);
  const toolbarTheme = useSelector(selectToolbarTheme);
  const handleOpen = (panelId) => {
    setOpen(panelId);
  };

  useEffect(() => {
    axios.get(`/v1/branch/get-by-id/${user.branch_id}`).then(response => {
      setBranch(response.data);
    })

  }, [user]);

  const handleCurrency = () => {
    axios.put(`/v1/setting/currency/editCurrency/amount?newAmount=${currency}.00`).then(response => {
      if (response.data) {
        dispatch(showMessage({ message: t("Success"), variant: 'success', }));
        setIsSave(!is_save)
      }
    }).catch(error => {
      dispatch(showMessage({ message: error.response.data.message, variant: 'error', status: error.response.data.status, url: error.response.request.responseURL }));
    });
  }


  const handleChange = (id) => {
    axios.post(`/v1/auth/switch-branch?user_id=${user.user_id}&branch_id=${id}`).then(response => {
      window.location.reload()
    });

  }

  const handleClearCache = async () => {
    try {
      if ('caches' in window) {
        const cacheNames = await caches.keys();
        await Promise.all(cacheNames.map((cacheName) => caches.delete(cacheName)));
      }

      if ('serviceWorker' in navigator) {
        const registrations = await navigator.serviceWorker.getRegistrations();
        await Promise.all(registrations.map((registration) => registration.unregister()));
      }
    } finally {
      const refreshUrl = new URL(window.location.href);
      refreshUrl.searchParams.set('refresh', Date.now().toString());
      window.location.replace(refreshUrl.toString());
    }
  }

  useEffect(() => {
    axios.get(`v1/client/get-all`).then(response => {
      const sortDataById = response?.data.sort((a, b) => a.id - b.id);
      setContinentData(sortDataById);
    });
  }, []);

  useEffect(() => {
    axios.get(`/v1/setting/currency/get-all`).then(response => {
      const sortDataByDate = response?.data.sort((a, b) => new Date(b.oper_day) - new Date(a.oper_day));
      const latestCurrency = sortDataByDate[0]?.amount;
      setCurrency(latestCurrency);
      setCurrencyData(sortDataByDate);

    });
  }, [is_save]);

  useEffect(() => {
    axios.get(`v1/branch/get-all`).then(response => {
      if (response.data == "Invalid or expired token") {
        window.location.reload();
      }
      const sortDataById = response?.data.sort((a, b) => a.id - b.id);
      setComp(sortDataById);
    });
  }, []);
  return (
    <ThemeProvider theme={toolbarTheme}>
      <AppBar
        id="fuse-toolbar"
        className={clsx('flex relative z-20 shadow-md', props.className)}
        color="default"
        sx={{
          backgroundColor: (theme) =>
            theme.palette.mode === 'light'
              ? toolbarTheme.palette.background.paper
              : toolbarTheme.palette.background.default,
        }}
        position="static"
      >
        <Toolbar className="p-0 min-h-48 md:min-h-64">
          <div className=" px-16">
            {config.navbar.display && config.navbar.position === 'left' && (
              <>
                <Hidden lgDown>
                  {(config.navbar.style === 'style-3' ||
                    config.navbar.style === 'style-3-dense') && (
                      <NavbarToggleButton className="w-40 h-40 p-0 mx-0" />
                    )}

                  {config.navbar.style === 'style-1' && !navbar.open && (
                    <NavbarToggleButton className="w-40 h-40 p-0 mx-0" />
                  )}
                </Hidden>

                <Hidden lgUp>
                  {/* <Link to='/home' role="button" key="home">                            
                        <FuseSvgIcon className="w-24 h-24">heroicons-outline:home</FuseSvgIcon>
                  </Link> */}

                  {/* <NavbarToggleButton className="w-40 h-40 p-0 mx-0 sm:mx-8" /> */}
                </Hidden>
              </>
            )}
            {/* <NavigationSearch /> */}
          </div>
          <div className='grid grid-cols-7  sm:grid-cols-3 items-center w-full'>
            <div className='flex hidden sm:block items-center'>
              <Autocomplete
                id="combo-box-continent"
                className='w-3/4'
                sx={{
                  "& .MuiOutlinedInput-input": {
                    // padding: " 10px 6px !important",
                    fontSize: "11px",
                    fontWeight: 500,
                  },
                  "& fieldset": {
                    borderColor: 'transparent !important',
                    borderRadius: '33px'
                  },
                  '&::placeholder': {
                    color: 'black',
                    fontSize: "11px",
                    opacity: 0.7,
                  },
                }}
                component={motion.div}
                initial={{ y: -20, opacity: 0 }}
                animate={{ y: 0, opacity: 1, transition: { delay: 0.2 } }}
                value={continent}
                // sx={{ '& fieldset': { borderRadius: 33 } }}
                freeSolo
                clearOnBlur={true}
                onInputChange={(event, newInputValue) => {
                  setInputValue(newInputValue);
                }}
                options={inputValue.length >= 3 ? continentData : []}
                getOptionLabel={(option) => option.name ? `${option.name} (${option.phone_number})` : ''}
                renderOption={(props, option) => (
                  <Box component="li" {...props} key={option.id}>
                    {option.name} ({option.phone_number})
                  </Box>
                )}
                onChange={(event, value) => {
                  setProductData(value)
                  value && navigate('/clients/clients', { state: value });
                }}

                isOptionEqualToValue={(option, value) => option.value === value.value}
                renderInput={(params) => (
                  <TextField
                    clearOnBlur={true}
                    onKeyDown={(e, v) => {
                      if (e.key === 'Enter' && productData) {
                        navigate('/clients/clients', { state: productData });
                      }
                    }}
                    {...params}
                    sx={{ padding: '0!important' }}
                    InputProps={{
                      ...params.InputProps,
                      startAdornment: (
                        <FuseSvgIcon className="mr-2" size={18} color="disabled">heroicons-solid:search</FuseSvgIcon>
                      ),
                      style: { padding: "0px 8px", }
                    }}
                    className=" flex p-0  items-center  bg-grey-100 text-14 rounded-full border-1 shadow-0 w-full "
                    placeholder={t('SearchClientServicesCreatingVisit')} />

                )}
              />
            </div>

            <div className='m-auto  text-center col-span-6 sm:col-span-1'>
              <Typography className='text-16 font-600'>{branch.name}</Typography>
              <Typography className='text-13 font-400'>{branch.address}</Typography>
              {(user.role == "SUPER_ADMIN") &&
                <>
                  <Typography aria-controls="basic-menu"
                    aria-haspopup="true"
                    onClick={handleClick}
                    color="secondary" className='text-10 font-400 cursor-pointer'>{t("SelectABranch")}</Typography>
                  <Menu
                    id="basic-menu"
                    anchorEl={anchorEl}
                    open={Boolean(anchorEl)}
                    onClose={handleClose}
                    sx={
                      {
                        left: `${isMobile ? '0px' : '20px'}`,
                        top: "28px!important",

                      }

                    }
                  >
                    {comp.map(row => (
                      <MenuItem value={row.id} className='block m-auto text-left hover:opacity-20 p-12 text-13 ' sx={{ borderBottom: "1px solid #eeeff1" }} onClick={(e) => { handleChange(e.target.value), handleClose(), setOpen(true) }}> {row.name} </MenuItem>
                    ))}
                  </Menu>
                </>}
            </div>
            <Hidden lgUp>
              <div className="flex items-center justify-end gap-8 pr-12">
                <IconButton
                  className="w-36 h-36"
                  onClick={handleClearCache}
                  title="Cache tozalash"
                >
                  <FuseSvgIcon color="secondary" className="w-22 h-22">heroicons-outline:refresh</FuseSvgIcon>
                </IconButton>
                <Link className="flex justify-end" to="/sign-out">
                  <FuseSvgIcon color='error' className="w-24 h-24">heroicons-outline:logout</FuseSvgIcon>
                </Link>
              </div>
            </Hidden>
            <div className=" hidden sm:flex items-center  justify-end mr-16  px-8 h-full overflow-x-auto">

              <UserMenu />
              <Button
                className="min-w-40 w-40 h-40 m-0 hidden lg:flex"
                onClick={handleClearCache}
                variant="text"
                color="inherit"
                disableRipple
                title="Cache tozalash"
              >
                <FuseSvgIcon color="secondary" size={24}>heroicons-outline:refresh</FuseSvgIcon>
              </Button>
              <Button
                className="settingsButton min-w-40 w-40 h-40 m-0 hidden lg:flex"
                onClick={() => handleOpen('settings')}
                variant="text"
                color="inherit"
                disableRipple
              >
                <span >
                  <FuseSvgIcon sx={{ animation: 'rotating 5s linear infinite' }} color="default" size={28}>feather:settings</FuseSvgIcon>
                </span>
              </Button>

            </div>
          </div>
          {config.navbar.display && config.navbar.position === 'right' && (
            <>
              <Hidden lgDown>
                {!navbar.open && <NavbarToggleButton className="w-40 h-40 p-0 mx-0" />}
              </Hidden>

              <Hidden lgUp>
                <NavbarToggleButton className="w-40 h-40 p-0 mx-0 sm:mx-8" />
              </Hidden>
            </>
          )}
        </Toolbar>
      </AppBar>

      <StyledDialog
        TransitionComponent={Transition}
        aria-labelledby="settings-panel"
        aria-describedby="settings"
        open={open === 'settings'}
        onClose={handleClose}
        BackdropProps={{ invisible: true }}
        classes={{
          paper: 'shadow-lg',
        }}
        {...settingsHandlers}
      >
        <FuseScrollbars className="p-16 sm:p-32">
          <IconButton
            className="fixed top-0 ltr:right-0 rtl:left-0 z-10"
            onClick={handleClose}
            size="large"
          >
            <FuseSvgIcon>heroicons-outline:x</FuseSvgIcon>
          </IconButton>

          <Typography className="mb-32" variant="h6">
            {t("Settings")}
          </Typography>


          <FuseThemeSchemes
            themes={themesConfig}
            onSelect={(_theme) => {
              dispatch(changeFuseTheme(_theme));
            }}
          />

          <LanguageSwitcher />

          <AdjustFontSize />

          <HeaderFullScreenToggle />

          {user.role == "SUPER_ADMIN" &&
            <div className='flex items-center gap-8 mt-8'>
              <TextField
                className='block '
                label={t("CurrencyRate")}
                value={currency}
                name="document_number"
                onChange={(e) => {
                  setCurrency(e.target.value)
                }}
              />

              <Button onClick={handleCurrency} className='rounded-4' variant="contained" color="secondary" >
                {t('Save')}
              </Button>

              <IconButton
                className=""
                onClick={(e) => (setHistoryCurrency(!historyCurrency))}

              >
                <FuseSvgIcon>{historyCurrency ? `feather:eye-off` : `feather:eye`}</FuseSvgIcon>
              </IconButton>
            </div>}

          {historyCurrency && <div className='mt-16'>
            <Typography className='font-600 text-18'>{t("CurrencyHistory")}</Typography>
            {currencyData.map((n) => (
              <Typography className='my-1' key={n.id}>
                {n.oper_day} {t("date")} {n.amount} {t("Sum")}
              </Typography>
            ))}
          </div>}


        </FuseScrollbars>
      </StyledDialog>
    </ThemeProvider>
  );
}

export default memo(ToolbarLayout1);
